<template>
    <b-form-select v-model="distance" class="distance-select">
        <option disabled :value="null">
            Default
        </option>
        <option
            v-for="option in distanceOptions"
            :key="option.value"
            :value="option.value"
            @click="selectDistance(option)"
        >
            {{ option.text }}
        </option>
    </b-form-select>
</template>

<script>
export default {
    name: "DistanceSelector",

    props: {
        distance: {
            type: Number,
            required: true,
            default: null,
        },
        distanceOptions: {
            type: Array,
            required: true,
            default: () => [],
        },
    },

    methods: {
        selectDistance(option) {
            this.distance = option.value;
            this.$emit("distance-selected", option);
        },
    },
};
</script>

<style lang="scss" scoped>
.distance-select {
    min-width: 140px;
    height: 34px;
    font-style: italic;
}
</style>
